// extracted by mini-css-extract-plugin
export var csatScore = "_nu-5";
export var header = "_nu-1";
export var panelWrapper = "_nu-2";
export var postPreview = "_nu-3";
export var rightContent = "_nu-0";
export var wrappingText = "_nu-4";